import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DateService, DataService } from 'app/services';
import { EmailReceiptComponent } from 'app/modules/shared/components/email-receipt/email-receipt.component';

import { datetimeFormat } from 'app/constants/date-time-format';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-email-receipt-resend',
  templateUrl: './email-receipt-resend.component.html',
  styleUrls: ['./email-receipt-resend.component.scss'],
})
export class EmailReceiptResendComponent implements OnInit {
  isArchived: boolean;
  paymentId: any = null;
  payment: any = {};
  usd = currency.USD;
  restriction = { employeeName: '', token: '' };
  isOrderRestricted: boolean = false;
  isLoading: boolean = false;

  constructor(
    public dateService: DateService,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private dialogConfig: DynamicDialogConfig,
    private dialogService: DialogService,
    public helperService: HelperService,
    public dataService: DataService
  ) { }

  ngOnInit() {
    const data = this.dialogConfig.data;
  
    if (data && data.paymentId) {
      this.paymentId = data.paymentId;
      this.getPaymentDetails(this.paymentId);
    }
  }

  getPaymentDetails(paymentId: string) {
    this.isLoading = true;
    this.httpService
      .getPaymentById(paymentId)
      .then(
        (payment: any) => {
          if (payment) {
            const estimate = payment.estimate.estimateId || {};

            this.payment = payment;
            this.isArchived = estimate.isArchived || estimate.isFinalized;

            if (this.dataService.isLockOrderEnabled && estimate.restriction) {
              this.restriction = estimate.restriction;
              this.isOrderRestricted = estimate.restriction.status === 'restricted' && !this.helperService.isLockOrderSessionExist(estimate.restriction.token);
            }

            if (!!payment.paymentDate) {
              this.payment.paymentDate = new Date(this.payment.paymentDate);
            } else {
              this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(new Date(this.payment.createdAt).getTime());
            }

            this.payment.createdAt = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.mmmdyyhhmmaa);

            payment.tooltip = this.helperService.createPaymentLogTooltip(this.payment);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }

  optionHandler(type: string) {
    if (this.isLoading || this.isArchived || this.isOrderRestricted || this.payment?.paymentType === 'writeOff' )  return;

    if (type === 'email') {
      this.closeDialog();
      const ref = this.dialogService.open(EmailReceiptComponent, {
        width: '645px',
        styleClass: 'add-dialog fixedWidthModal',
        showHeader: false,
        data: {
          estimate: { estimateId: this.payment.estimate.estimateId._id },
          payment: this.payment,
        },
      });
    } else if (type === 'print') {
      if (this.payment.isPdfUploaded) {
        if (this.payment.signedReceiptLink) {
          window.open(this.payment.signedReceiptLink, '_blank');
        } else {
          window.open(this.payment.receiptLink, '_blank');
        }
      } else {
        window.open(this.payment.previewLink, '_blank');
      }
    } else if (type === 'edit') {
      this.dynamicDialogRef.close({ type: 'edit', paymentId: this.paymentId, payment: this.payment });
    }
  }
}
